import angular from 'angular';
import {
  ssDialogService,
  pmDataService,
  loaderService,
} from 'app/services';
import { alerts } from 'app/components/global';
import template from './sync-section-compare-dialog.html';
import controller from './sync-section-compare-dialog.controller';

class dialogService {
  getOptions($event, { section, changes, changeArrays }) {
    return {
      controller,
      controllerAs: 'syncSectionCompareDialogVM',
      locals: {
        section,
        changes,
        changeArrays,
      },
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.syncSectionCompareDialog', [
  pmDataService,
  ssDialogService,
  loaderService,
  alerts,
])
  .service('syncSectionCompareDialog', dialogService)
  .name;
